import React, { useEffect, useState } from "react";
import styles from "./ThroughResearch.module.css";
import Image from "next/image";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

interface ThroughResearchProps {
  data?: {
    cta?: any;
    card_with_image?: {
      title_description?: {
        title?: string;
        description?: string;
      };
      images?: Array<{
        url?: string;
      }>;
      mobiles_images?: Array<{
        url?: string;
      }>;
    };
  } | null;
}

const ThroughResearch: React.FC<ThroughResearchProps> = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);
  const MemoizedCustomiseCta = React.memo(CustomiseCta);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 700);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container" style={{ minHeight: "500px" }}>
      <div className={styles.containerResearch}>
        <div className={styles.textContainer}>
          <h2 className={styles.heading}>
            {data?.card_with_image?.title_description?.title || ""}
          </h2>
          <p className={styles.description}>
            {data?.card_with_image?.title_description?.description || ""}
          </p>
          <div className={styles.Desktopbutton}>
            <MemoizedCustomiseCta
              ctaData={data?.cta}
              position="left"
              btnLabelDesktop="Explore our research"
            />
          </div>
        </div>
        <div className={styles.imageContainer}>
          {data?.card_with_image?.images?.[0]?.url && (
            <Image
              src={data?.card_with_image?.images[0].url}
              alt={
                data?.card_with_image?.title_description?.title ||
                "Research presentation"
              }
              title={
                data?.card_with_image?.title_description?.title ||
                "Research presentation"
              }
              className={styles.image}
              width={642}
              height={isMobile ? 250 : 420}
              quality={80}
              loading="lazy"
              priority={false}
            />
          )}
          <div className={styles.mobilebutton}>
            <MemoizedCustomiseCta
              ctaData={data?.cta}
              position="down"
              btnLabelDesktop="Explore our research"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThroughResearch;
